import { createDatePickerAdder } from './createDatePickerAdder'

export const addComponentForDateTimeField = createDatePickerAdder(
  'dateTimeFieldTemplate',
)
